import React, {Fragment, useContext} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {ProjectMenuContext} from "../Contexts/ProjectMenuContext";
import ReactGA from "react-ga";
import {ReactComponent as BlackRight} from "../../../images/arrowRightBlack.svg";
import {ProjectContext} from "../Contexts/ProjectContext";

export default function Dashboard(props) {
    const {closeMobileMenu} = useContext(ProjectMenuContext)
    const {project, setMobileText, setActivePage} = useContext(ProjectContext);
    const intl = useIntl();

    const activePage = () => {
        return project.activePage === "Dashboard" ? 'siteTitle siteTitleActive menuItem menuItemActive' : 'siteTitle menuItem'
    }

    const requestDashboard = () => {
        setActivePage("Dashboard");
        setMobileText(intl.formatMessage({id: "dashboard.label", defaultMessage: "Dashboard"}));
        closeMobileMenu();

        // Google Analytics
        ReactGA.event({
            category: "Project Menu Selection",
            action: `Clicked on "Dashboard" on Project "${window.location.pathname}"`
        })

        // Google Tag Manager
        window.dataLayer.push({
            'event': "Pageview",
            'pagePath': `${window.location.pathname}/dashboard`,
            'pageTitle': `Dashboard`
        })
    }

    return (
        <Fragment>
            {(props.projectStats === 'true' || props.projectStats === true) &&
            <Fragment>
                {!props.mobile &&
                <div>
                    <h1 onClick={() => requestDashboard()} className={activePage()}>
                        <FormattedMessage id="dashboard.label" defaultMessage="Dashboard"/>
                    </h1>
                </div>
                }
                {props.mobile &&
                <div onClick={() => requestDashboard()} className='entireSiteMobile'>
                    <div className='mobileText'>
                        <FormattedMessage id="dashboard.label" defaultMessage="Dashboard"/>
                    </div>
                    <div className="floatRight mobileArrow"><BlackRight/></div>
                </div>
                }
            </Fragment>
            }
        </Fragment>
    )
}